import { instanciaActual } from '@/lib/instancia';

/**
 * Cartel de instancia, arriba del formulario de login.
 *
 * Hay DOS despliegues de esta app y, hasta el 2026-09-18, sus logins eran
 * idénticos. Ahora se distinguen a primera vista:
 *
 *  - **la nueva (producción)**: no muestra cartel — la identifican el
 *    encabezado BET SUPPLIER y el pie de Coopen Studio (`MarcaBet`).
 *  - **la vieja**: "¡Nos estamos mudando!".
 *  - **un servidor desconocido**: franja roja. No se da por bueno en silencio.
 *
 * ⚠️ El texto de la vieja tiene que ser VERDAD en los dos momentos de la
 * migración. `facturacion-web-46u.pages.dev` es el MISMO proyecto que sirve
 * `appfacturacion.betsupplier.co`, así que antes de mover el dominio este cartel
 * lo ven todos los usuarios — y en ese momento esa ES la producción. Por eso no
 * dice "no cargue facturas acá": sería falso y alarmaría a gente que está
 * trabajando bien. Dice lo que pasa y lo que tienen que hacer, que es nada.
 *
 * Castellano de Colombia, trato de usted: es como le habla el cliente a su gente.
 */
export function AvisoInstancia() {
  const i = instanciaActual();

  if (i.esProduccion) return null;

  if (!i.conocida) {
    return (
      <div role="status" className="mb-5 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-900">
        <p className="font-semibold">Servidor no reconocido</p>
        <p className="mt-1 leading-relaxed">
          Esta pantalla está conectada a un servidor que no figura en la lista.
          <strong> No cargue facturas acá</strong> hasta confirmar cuál es.
        </p>
        <p className="mt-2 text-xs opacity-80">
          Servidor: <span className="font-mono">{i.host}</span>
        </p>
      </div>
    );
  }

  return (
    <div
      role="status"
      className="mb-6 overflow-hidden rounded-lg border border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 shadow-sm"
    >
      <div className="flex gap-3 px-4 py-4">
        {/* Camión de mudanza, dibujado a mano: el repo no usa emoji como ícono. */}
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          className="mt-0.5 h-6 w-6 flex-none text-amber-600"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 7h11v9H3z" />
          <path d="M14 10h4l3 3v3h-7" />
          <circle cx="7" cy="17.5" r="1.6" />
          <circle cx="17" cy="17.5" r="1.6" />
        </svg>
        <div className="text-sm text-amber-950">
          <p className="text-base font-bold tracking-tight">¡Nos estamos mudando!</p>
          <p className="mt-1 leading-relaxed">
            Estamos trasladando la plataforma a un servidor nuevo, más rápido y más
            seguro. <strong>Sus facturas están a salvo: no se pierde ninguna.</strong>
          </p>
          <p className="mt-1.5 leading-relaxed">
            En los próximos días le va a tocar volver a iniciar sesión. Eso es todo.
          </p>
          <p className="mt-2.5 text-xs text-amber-800">
            Siga ingresando por <span className="font-semibold">appfacturacion.betsupplier.co</span>
          </p>
        </div>
      </div>
    </div>
  );
}
